<!-- Entity Selection Dialog -->
<p-table
  #table
  [value]="fieldsInGroup$ | async"
  dataKey="field"
  styleClass="p-datatable-striped p-datatable-gridlines custom-overflow"
  jmlLibInitCallback
  (init)="afterTableInit()"
>
  <ng-template pTemplate="body" let-rowData>
    <tr [pSelectableRow]="rowData">
      <td class="w-6">
        <span class="flex align-items-center" style="min-height: 2.4rem">
          {{ rowData.header }}
        </span>
      </td>
      <td class="w-6" id="hoverEffect" style="position: relative" [ngSwitch]="rowData.type">
        <jml-lib-string-cell
          *ngSwitchCase="'String'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [mandatory]="rowData.mandatory"
        ></jml-lib-string-cell>
        <jml-lib-integer-cell
          *ngSwitchCase="'int'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-integer-cell>
        <jml-lib-float-cell
          *ngSwitchCase="'float'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [decimals]="rowData.decimals"
        ></jml-lib-float-cell>
        <jml-lib-bool-cell
          *ngSwitchCase="'boolean'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-bool-cell>
        <jml-lib-currency-cell
          *ngSwitchCase="'Currency'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [currency]="currency"
        ></jml-lib-currency-cell>
        <jml-lib-json-cell
          *ngSwitchCase="'json'"
          (completeCellEdit)="completeCellEdit($event)"
          [header]="configuration.singleDisplayName + ' ' + data['_repr_'] + ' - ' + rowData.header"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-json-cell>
        <jml-lib-python-cell
          *ngSwitchCase="'python'"
          (completeCellEdit)="completeCellEdit($event)"
          [header]="configuration.singleDisplayName + ' ' + data['_repr_'] + ' - ' + rowData.header"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-python-cell>
        <jml-lib-multiline-cell
          *ngSwitchCase="'Multiline'"
          (completeCellEdit)="completeCellEdit($event)"
          [header]="configuration.singleDisplayName + ' ' + data['_repr_'] + ' - ' + rowData.header"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [mandatory]="rowData.mandatory"
        ></jml-lib-multiline-cell>
        <jml-lib-icon-cell
          *ngSwitchCase="'Icon'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [header]="rowData.header"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [catalogueHrid]="rowData.defaultCatalogue"
        ></jml-lib-icon-cell>
        <jml-lib-address-cell
          *ngSwitchCase="'Address'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [mandatory]="rowData.mandatory"
        ></jml-lib-address-cell>
        <jml-lib-date-period-cell
          *ngSwitchCase="'DatePeriod'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
          [mandatory]="rowData.mandatory"
        ></jml-lib-date-period-cell>
        <jml-lib-calendar-week-cell
          *ngSwitchCase="'CalendarWeek'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-calendar-week-cell>
        <jml-lib-color-cell
          *ngSwitchCase="'Color'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-color-cell>
        <jml-lib-icon-picker-cell
          *ngSwitchCase="'IconDefinition'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [editable]="isEditable(rowData)"
        ></jml-lib-icon-picker-cell>
        <jml-lib-fsm-cell
          *ngSwitchCase="'State'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="rowData.field"
          [rowData]="data"
          [entityType]="configuration.type"
          [editable]="isEditable(rowData)"
        ></jml-lib-fsm-cell>
        <ng-container *ngSwitchDefault>
          <jml-lib-entity-reference-cell
            *ngIf="_isEntityReference(rowData)"
            (completeCellEdit)="completeCellEdit($event)"
            [fieldName]="rowData.field"
            [rowData]="data"
            [field]="rowData"
            [editable]="isEditable(rowData)"
            [dtoType]="configuration.type"
            [mandatory]="rowData.mandatory"
          ></jml-lib-entity-reference-cell>

          <jml-lib-drop-down-wrapper
            *ngIf="rowData.type === 'dtoType' || _isCatalogueEntry(rowData)"
            (completeCellEdit)="completeCellEdit($event)"
            [editable]="isEditable(rowData)"
            [rowData]="data"
            [entityId]="data.id"
            [field]="rowData"
            [dtoType]="configuration.type"
          ></jml-lib-drop-down-wrapper>

          <jml-lib-date-cell
            *ngIf="rowData.type === 'Date' || rowData.type === 'DateTime'"
            (completeCellEdit)="completeCellEdit($event)"
            [fieldName]="rowData.field"
            [rowData]="data"
            [editable]="isEditable(rowData)"
            [showTime]="rowData.type === 'DateTime'"
            [mandatory]="rowData.mandatory"
          ></jml-lib-date-cell>
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
